module.exports = __webpack_public_path__ + "ac47c736c9da60f28541503045e17987.jpg";